import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const WishlistContext = createContext();
const KEY = "eg_wishlist";

export function WishlistProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const has = (slug) => items.some((i) => i.slug === slug);

  const toggle = (product) => {
    setItems((prev) => {
      if (prev.some((i) => i.slug === product.slug)) {
        toast("Removed from wishlist");
        return prev.filter((i) => i.slug !== product.slug);
      }
      toast.success("Saved to wishlist");
      return [...prev, {
        slug: product.slug, name: product.name, price: product.sale_price || product.price,
        thumbnail: product.thumbnail, category: product.category, rating: product.rating,
      }];
    });
  };

  return (
    <WishlistContext.Provider value={{ items, has, toggle, count: items.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
